export default {
  root: {
    '&.MuiStepConnector-alternativeLabel': {
      top: 24,
    },
  },
  line: {
    display: 'block',
    height: 10,
    border: 'none',
    borderRadius: 1,
    //backgroundColor: '#E8E8E8',
    backgroundColor: '#518CBF',
  },
};
